import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const Crop54Icon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"crop_5_4"} ref={ref}/>
});

Crop54Icon.displayName = "Crop54Icon";
